import { Navigation } from '@models/navigation.model';

export const navigationData: Navigation = {
    compact: [],
    futuristic: [],
    horizontal: [],
    default: [
        {
            id: 'dashboard',
            title: 'dashboard',
            type: 'basic',
            icon: 'heroicons_outline:home',
            link: '/dashboard',
            perm: ['read_dashboard', '', '', ''],
            isAccessControl: true,
        },
        {
            id: 'import.from.china.flow',
            title: 'international.trade',
            subtitle: 'international.trade.TQ.VN',
            type: 'group',
            children: [
                {
                    id: 'import.from.china.flow.main',
                    title: 'import.process',
                    type: 'collapsable',
                    icon: 'heroicons_outline:view-boards',
                    children: [
                        {
                            id: 'import.from.china.flow01',
                            title: 'order.import',
                            type: 'basic',
                            link: '/import-process/create-import',
                            perm: ['', 'create_import', '', ''],
                            isAccessControl: true,
                        },
                        {
                            id: 'import.from.china.flow02',
                            title: 'import.management',
                            type: 'basic',
                            link: '/import-process/import-management',
                            perm: [
                                'read_import',
                                '',
                                'update_import',
                                'delete_import',
                            ],
                            isAccessControl: true,
                        },
                        {
                            id: 'import.from.china.flow03',
                            title: 'create.trans.cn',
                            type: 'basic',
                            link: '/import-process/create-export',
                            perm: ['', 'create_export', '', ''],
                            isAccessControl: true,
                        },
                        {
                            id: 'import.from.china.flow04',
                            title: 'export.management',
                            type: 'basic',
                            link: '/import-process/export-management',
                            perm: [
                                'read_export',
                                '',
                                'update_export',
                                'delete_export',
                            ],
                            isAccessControl: true,
                        },
                    ],
                },
            ],
        },
        {
            id: 'transportation.flow',
            title: 'transportation',
            subtitle: 'inland.transportation.VN',
            type: 'group',
            children: [
                {
                    id: 'dashboard.inland.transportation.main',
                    title: 'shipping.process',
                    type: 'collapsable',
                    icon: 'mat_outline:local_shipping',
                    children: [
                        {
                            id: 'dashboard.inland.transportation.flow01',
                            title: 'create.order',
                            type: 'basic',
                            link: '/order/new',
                            perm: ['', 'create_order', '', ''],
                            isAccessControl: true,
                        },
                        {
                            id: 'dashboard.inland.transportation.flow02',
                            title: 'order.management',
                            type: 'basic',
                            link: '/order/order-management',
                            perm: [
                                'read_order',
                                '',
                                'update_order',
                                'delete_order',
                            ],
                            isAccessControl: true,
                        },
                        {
                            id: 'dashboard.inland.transportation.flow03',
                            title: 'deliver.order',
                            type: 'basic',
                            link: '/order/deliver',
                            perm: [
                                'read_order_deliver',
                                'create_order_deliver',
                                '',
                                '',
                            ],
                            isAccessControl: true,
                        },
                        {
                            id: 'dashboard.inland.transportation.flow03',
                            title: 'export.management',
                            type: 'basic',
                            link: '/order/export-management',
                            perm: [
                                'read_export_management',
                                '',
                                'update_export_management',
                                'delete_export_management',
                            ],
                            isAccessControl: true,
                        },
                    ],
                },
            ],
        },
        {
            id: 'management.flow',
            title: 'general.management',
            subtitle: 'management',
            type: 'group',
            children: [
                {
                    id: 'management.stock.management.flow01',
                    title: 'stock.management',
                    type: 'basic',
                    icon: 'mat_outline:storage',
                    link: '/stock-management',
                    perm: [
                        'read_stock',
                        'create_stock',
                        'update_stock',
                        'delete_stock',
                    ],
                    isAccessControl: true,
                },
                {
                    id: 'management.vehicle.management.flow02',
                    title: 'vehicle.management',
                    type: 'basic',
                    icon: 'mat_outline:directions_car',
                    link: '/vehicle-management',
                    perm: [
                        'read_vehicle',
                        'create_vehicle',
                        'update_vehicle',
                        'delete_vehicle',
                    ],
                    isAccessControl: true,
                },
                {
                    id: 'management.customer.management.flow03',
                    title: 'customer.management',
                    type: 'basic',
                    icon: 'heroicons_outline:user-group',
                    link: '/customer-management',
                    perm: [
                        'read_customer',
                        'create_customer',
                        'update_customer',
                        'delete_customer',
                    ],
                    isAccessControl: true,
                },
            ],
        },
        {
            id: 'profile',
            title: 'profile',
            type: 'group',
            subtitle: 'account.setting',
            children: [
                {
                    id: 'profile.account',
                    title: 'account.information',
                    type: 'basic',
                    icon: 'heroicons_outline:user',
                    link: '/setting',
                },
                {
                    id: 'profile.signout',
                    title: 'sign.out',
                    type: 'basic',
                    icon: 'heroicons_outline:logout',
                    link: '/sign-out',
                },
            ],
        },
    ],
};

export const navigationDataAdmin: Navigation = {
    compact: [],
    futuristic: [],
    horizontal: [],
    default: [
        {
            id: 'dashboard',
            title: 'Trang chủ',
            type: 'basic',
            icon: 'heroicons_outline:home',
            link: '/dashboard',
        },
        {
            id: 'admin',
            title: 'Quản trị',
            subtitle: 'Trung tâm kiếm soát',
            type: 'group',
            children: [
                {
                    id: 'userManagement',
                    title: 'Quản lý nhân viên',
                    type: 'basic',
                    icon: 'heroicons_outline:cube',
                    link: '/user-management',
                },
                {
                    id: 'auditLog',
                    title: 'Nhật ký hoạt động',
                    type: 'basic',
                    icon: 'heroicons_outline:ticket',
                    link: '/audit-log',
                },
            ],
        },
        {
            id: 'profile',
            title: 'Hồ sơ',
            type: 'group',
            subtitle: 'Chỉnh sửa thông tin',
            children: [
                {
                    id: 'profile.account',
                    title: 'Thông tin tài khoản',
                    type: 'basic',
                    icon: 'heroicons_outline:user',
                    link: '/setting',
                },
                {
                    id: 'profile.signout',
                    title: 'Đăng xuất',
                    type: 'basic',
                    icon: 'heroicons_outline:logout',
                    link: '/sign-out',
                },
            ],
        },
    ],
};
